import HistoryTrackingBase from './historyTrackingBase'
class DrugBase extends HistoryTrackingBase {
  constructor (modifiedDate, modifiedByHsaId, modifiedByName, isPublished) {
    super(modifiedDate, modifiedByHsaId, modifiedByName)
    this.isPublished = isPublished
  }
}

export default DrugBase
